import { Button, ButtonProps, Typography } from '@mui/material';
import { FC } from 'react';

const ButtonWithFont: FC<ButtonProps> = (props) => (
  <Button {...props}>
    <Typography variant="bodySingle">{props.children}</Typography>
  </Button>
);
export { ButtonWithFont as Button };
